import z from "zod"
import { ClusterDomainEnum } from "../../insights/response_data"

export const BiasFilterEnum = {
  All: "all",
  Biased: "biased",
  Unbiased: "unbiased",
}

export type BiasFilter = (typeof BiasFilterEnum)[keyof typeof BiasFilterEnum]

export const GetBackofficeClusterKeysSchema = z.object({
  companyId: z.string().transform(BigInt).optional(),
  domain: z.nativeEnum(ClusterDomainEnum).optional(),
  goalId: z.string().transform(BigInt).optional(),
  campaignId: z.string().transform(BigInt).optional(),
  from: z
    .string()
    .transform((val) => new Date(val))
    .optional(),
  to: z
    .string()
    .transform((val) => new Date(val))
    .optional(),
})

export const UpdateClusterScoreSchema = z.object({
  key: z.string(),
  score: z.number().int().min(0).max(3),
})

export const GenerateClusterFormSchema = z.object({
  companyId: z.string().min(1, "Company is required"),
  from: z.string().min(1, "Week is required"),
  to: z.string().min(1, "Week is required"),
  domain: z.nativeEnum(ClusterDomainEnum),
  goalId: z.string().optional(),
  campaignId: z.string().optional(),
  epsilon: z.number().min(0).max(1).optional(),
  samplingFactor: z.number().optional(),
  selectionMethod: z.enum(["leaf", "eom"]).optional(),
  includeNoise: z.boolean().optional().default(true),
  biasFilter: z.nativeEnum(BiasFilterEnum).optional(),
})

export const DeleteClustersKeysSchema = z.object({
  keys: z.array(z.string().min(1)).min(1),
})
